var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 256,
    width: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
    fill: "none",
    stroke: "#385963",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/tik-tok.ed81f0efd3a271875a269c0dc14fead7.svg";
export { ForwardRef as ReactComponent };